import React from 'react';
import { jwtDecode } from 'jwt-decode';
import Verificacion from '../../../components/Verificacion';
import Suspendido from '../../../components/Suspendido';
import DashboardUsuario from './DashboardUsuario';
import DashboardTecnico from './DashboardTecnico';
import DashboardAdmin from './DashboardAdmin';
import './dashboard.css';

/**
 * Punto de entrada de /dashboard: valida el estado de la cuenta, decide
 * el layout y delega el contenido en uno de los 3 dashboards por rol.
 * La navegación/perfil/logout viven ahora en la sidebar global (components/Sidebar.jsx).
 */
const Dashboard = () => {
  const token = localStorage.getItem('AuthToken');
  const tokenInfo = token ? jwtDecode(token) : {};

  const handleLinkClick = () => window.scrollTo({ top: 0 });

  if (tokenInfo.estado === 'verificar') return <Verificacion />;
  if (tokenInfo.estado === 'suspendido') return <Suspendido />;

  const renderPanel = () => {
    if (tokenInfo.role === 'admin') return <DashboardAdmin tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
    if (tokenInfo.role === 'tecnico') return <DashboardTecnico tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
    return <DashboardUsuario tokenInfo={tokenInfo} onLinkClick={handleLinkClick} />;
  };

  return (
    <main className="site-width dash-content">
      {renderPanel()}
    </main>
  );
};

export default Dashboard;
